import { useTranslations } from '@vocab/react';
import { Box, Inline, Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { SparklingBadgeIcon } from 'src/libs/Icons';
import { MarkdownContent } from 'src/libs/MarkdownContent';

import translations from './.vocab';

import * as styles from './HighFitCalloutDesktop.css';

type Props = {
  highFitSummary: string;
};

export const HighFitCalloutDesktop: FC<Props> = ({ highFitSummary }) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="none">
      <Box width="full" className={styles.aiLine} />
      <Box paddingX="medium" paddingTop="medium">
        <Stack space="small">
          <Inline alignY="center" space="none">
            <Box marginBottom="xxsmall">
              <Text
                weight="strong"
                icon={<SparklingBadgeIcon className={styles.iconContainer} />}
              >
                {t('High-fit applicant')}
              </Text>
            </Box>
          </Inline>
          <MarkdownContent content={highFitSummary} />
          <Box paddingTop="xxsmall">
            <Text size="small" tone="secondary">
              {t(
                "The summary is AI-generated based on info from the applicant's CV, profile and screening question responses. AI-generated content may be inaccurate or inappropriate, so it's your responsibility to review the output. You're responsible for making all hiring decisions.",
              )}
            </Text>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};
